import * as React from 'react';
import { Box, TableCell, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useRow } from '../../providers';

const useStylesCell = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderLeft: `1px ${theme.palette.grey.A400} solid`,
      borderBottom: `1px ${theme.palette.grey.A400} solid`,
      padding: theme.spacing(1, 2),
    },
  })
);

type Props<Row> = {
  columnName: string;
  headtitle: string;
  children: (row: Row) => JSX.Element | JSX.Element[] | string;
  headtitleComponent?: ({
    headtitle,
    sortDirectionHandler,
  }: {
    headtitle: string;
    sortDirectionHandler?: () => void;
  }) => JSX.Element | JSX.Element[] | string;
  centered?: boolean;
};

/**
 * @summary Компонент отображения ячейки таблицы.
 *
 * @param props.children - Функция, принимающая объект с данными строки таблицы и возвращающая node для отображения.
 * @param props.headtitle - Заголовок столбца.
 * @param props.columnName - Идентификатор столбца.
 * @param props.filter - Параметры для создания фильтра по колонке.
 */
export const Cell = <Row,>({ children, centered = false }: Props<Row>) => {
  const rowContext = useRow();
  const classes = useStylesCell();

  const row = rowContext === undefined ? undefined : rowContext.row;
  return centered ? (
    <TableCell className={classes.root}>
      <Box display="flex" justifyContent="center">
        {children(row)}
      </Box>
    </TableCell>
  ) : (
    <TableCell className={classes.root}>{children(row)}</TableCell>
  );
};

export type CellType<Row> = (props: Props<Row>) => JSX.Element;

export type CellRender<Row> = React.FunctionComponentElement<Props<Row>>;
